module.exports = __webpack_public_path__ + "img/55.a767a6d7.jpg";